import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * /endpoint-security/people (and /shadow-ai/people, which forwards here): User 360 links one
 * person as `?person=<email>`. That person's page is /endpoint-security/users/:person; with no
 * person it is the Users list. Any other query param is kept.
 */
const EndpointPeopleRedirect = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const person = (params.get('person') || '').trim();
  params.delete('person');
  const rest = params.toString();
  const to = person ? `/endpoint-security/users/${encodeURIComponent(person)}` : '/endpoint-security/users';
  return <Navigate to={`${to}${rest ? `?${rest}` : ''}${location.hash}`} replace />;
};

export default EndpointPeopleRedirect;
